import axios from 'axios';
import { API_DOMAIN } from '../../constants';
import { mailRequest } from '../mailboxModel';

export async function signatureRequest(userId, options) {
  if (!userId) return mailRequest('/settings/signature', options);
  const response = await axios({ url: `${API_DOMAIN}/auth/users/${encodeURIComponent(userId)}/workspace-mailbox/signature`, method: 'get', ...options, headers: { accessToken: localStorage.getItem('accessToken') } });
  if (!response.data?.success) throw new Error(response.data?.message || 'Unable to load signature.');
  return response.data.data;
}
